import Divider from 'components/divider/divider';
import StyledDateInput from 'components/styledInput/StyledDateInput';
import { enGB, fr } from 'date-fns/locale';
import { useRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

registerLocale('en-GB', enGB);
registerLocale('fr-FR', fr);

const PlanningDateSection = ({
  dataCreateMission,
  handleDateStart,
  handleDateEnd,
  error1,
  error,
}) => {
  const endDatePickerRef = useRef(null);
  const onStartChange = (date) => {
    handleDateStart(date);
    if (
      endDatePickerRef.current &&
      (!dataCreateMission.dateEnd || dataCreateMission.dateEnd < date)
    ) {
      // Deferred so the start calendar finishes closing before the end one opens.
      setTimeout(() => endDatePickerRef.current?.setOpen(true), 0);
    }
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Période</div>
      <div className="flex gap-4">
        <div className="w-full flex flex-col gap-1.5">
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={dataCreateMission.dateStart}
            onChange={onStartChange}
            locale="fr-FR"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            disabledKeyboardNavigation
            dropdownMode="select"
            popperPlacement="bottom"
            customInput={<StyledDateInput label="Date de début" />}
          />
          {error1 && (
            <span className="ft-sm text-red-500">
              Veuillez indiquer une date valide
            </span>
          )}
        </div>
        <div className="w-full flex flex-col gap-1.5">
          <DatePicker
            ref={endDatePickerRef}
            dateFormat="dd/MM/yyyy"
            selected={dataCreateMission.dateEnd}
            onChange={handleDateEnd}
            openToDate={dataCreateMission.dateStart || undefined}
            locale="fr-FR"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            disabledKeyboardNavigation
            dropdownMode="select"
            popperPlacement="bottom"
            customInput={<StyledDateInput label="Date de Fin" />}
          />
          {error && (
            <span className="ft-sm text-red-500">
              Veuillez indiquer une date valide
            </span>
          )}
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default PlanningDateSection;
